<template>
  <div class="fixed top-0 left-0 z-10 w-full h-20 shadow-md bg-crimson">
    <div class="container px-4 mx-auto">
      <div class="flex flex-row justify-between py-3">
        <div class="flex flex-row gap-x-4">
          <a :href="VITE_APP_LEGISLATION_URL" target="_blank" rel="noopener">
            <div>
              <img
                alt="san-ha"
                class="object-contain"
                src="@/assets/icons/parliament_logo.svg"
                width="56"
                height="56"
              />
            </div>
          </a>
          <div class="flex flex-col justify-center">
            <p class="text-xl leading-none text-white">
              สำนักงานเลขาธิการวุฒิสภา
            </p>
            <p class="font-medium leading-none text-white">สรรหาแต่งตั้ง</p>
          </div>
        </div>
        <div class="flex flex-row items-center gap-x-4">
          <div>
            <a-tooltip
              v-if="!lodashIsEmpty(user)"
              title="แก้ไขโปรไฟล์"
              placement="bottom"
            >
              <router-link
                :to="{ name: ROUTE_NAMES.PROFILE }"
                aria-label="แก้ไขโปรไฟล์"
                class="flex flex-row items-center gap-x-2"
              >
                <UserIcon class="text-white w-9" />
                <div class="flex flex-col">
                  <p class="text-xl leading-none text-white">
                    {{ getRoleLabel(user.roleId) }}
                  </p>
                  <p class="font-medium leading-none text-white">
                    {{ displayName }}
                  </p>
                </div>
              </router-link>
            </a-tooltip>
            <UserIcon v-else class="text-white w-9" />
          </div>
          <div class="h-10 border-0 border-l border-white border-solid" />
          <div>
            <router-link
              v-if="lodashIsEmpty(user)"
              :to="{ name: ROUTE_NAMES.LOGIN }"
            >
              <p class="font-medium text-white cursor-pointer">เข้าสู่ระบบ</p>
            </router-link>
            <p
              v-else
              class="font-medium text-white cursor-pointer"
              @click="onClickSignOut"
            >
              ออกจากระบบ
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { UserInformation } from "@/apis/register/type";
import { localStorageKey } from "@/configs/enum";
import { ROUTE_NAMES } from "@/router/constants";
import { getUserInfo } from "@/utils/auth";
import { UserIcon } from "@heroicons/vue/24/solid";
import { message } from "ant-design-vue";
import lodashIsEmpty from "lodash/isEmpty";
import lodashIsEqual from "lodash/isEqual";
import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";

const VITE_APP_LEGISLATION_URL =
  import.meta.env.VITE_APP_LEGISLATION_URL || "#";

const route = useRoute();
const router = useRouter();

const user = ref<UserInformation | null>(null);

const displayName = computed(() => {
  if (!user.value) return "";
  const { firstName, lastName, fullName } = user.value;
  return firstName || lastName
    ? `${firstName ?? ""} ${lastName ?? ""}`.trim()
    : (fullName ?? "ผู้ใช้งาน");
});

const getRoleLabel = (roleId?: number): string => {
  switch (roleId) {
    case 19:
      return "ผู้ดูแลระบบ";
    default:
      return "ผู้ใช้งาน";
  }
};

function updateUser() {
  const userInfo = getUserInfo();
  if (!lodashIsEqual(user.value, userInfo)) {
    user.value = userInfo;
  }
}

onMounted(updateUser);

function clearQueryAndReload() {
  const basePath = window.location.origin + window.location.pathname;
  window.location.href = basePath;
}

function onClickSignOut() {
  message.info("ผู้ใช้ออกจากระบบ", 2);
  localStorage.removeItem(localStorageKey.REGISTER_USER_INFORMATION);
  user.value = null;
  setTimeout(() => {
    if (route.path !== "/") {
      router.push({ name: ROUTE_NAMES.HOME });
    } else {
      clearQueryAndReload();
    }
  }, 2000);
}
</script>
